// extracted by mini-css-extract-plugin
export default {"container":"_1sw3","paragraph":"_3F9B","button":"_2O1d","button_text":"gxST"};